import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react';
import { HeaderStore } from '../../stores/';
import './index.scss';

import page1Icon from '../../assets/footer/page1.png';
import page1ActionIcon from '../../assets/footer/page1_active.png';
import page2Icon from '../../assets/footer/page2.png';
import page2ActionIcon from '../../assets/footer/page2_active.png';
import page3Icon from '../../assets/footer/page3.png';
import page3ActionIcon from '../../assets/footer/page3_active.png';
import page4Icon from '../../assets/footer/page4.png';
import page4ActionIcon from '../../assets/footer/page4_active.png';
import page5Icon from '../../assets/footer/page5.png';
import page5ActionIcon from '../../assets/footer/page5_active.png';
import page6Icon from '../../assets/footer/page6.png';
import page6ActionIcon from '../../assets/footer/page6_active.png';
import downIcon from '../../assets/icons/down.png';
import leftIcon from '../../assets/icons/left.png';
import icon_more from '../../assets/icons/more.png';

declare global {
	interface Window {
		wx: any;
	}
}

interface Navs {
	url: string;
	icon: string;
	activeIcon: string;
	name: string;
	active: boolean;
	childrens?: { url: string, name: string, active: boolean }[];
	style?: any;
}

const Footer = observer((props: any) => {
	const [navs, setNavs] = useState<Array<Navs>>([{
		url: '/',
		icon: page1Icon,
		activeIcon: page1ActionIcon,
		name: '首 页',
		active: false,
		style: {
			left: 0
		}
	}, {
		url: '/page2',
		icon: page2Icon,
		activeIcon: page2ActionIcon,
		name: '全景鸟瞰',
		active: false,
		// style: {
		// 	left: '50px'
		// }
	}, {
		url: '/page3',
		icon: page3Icon,
		activeIcon: page3ActionIcon,
		name: '区位优势',
		active: false,
		// style: {
		// 	left: '100px'
		// }
	}, {
		url: '/page4',
		icon: page4Icon,
		activeIcon: page4ActionIcon,
		name: '户型鉴赏',
		active: false,
		// style: {
		// 	left: '150px'
		// }
	}, {
		url: '/page5',
		icon: page5Icon,
		activeIcon: page5ActionIcon,
		name: '阳台景观',
		active: false,
		// style: {
		// 	left: '200px'
		// }
	}, {
		url: '/page6',
		icon: page6Icon,
		activeIcon: page6ActionIcon,
		name: '品牌楼书',
		active: false,
		// style: {
		// 	left: '250px'
		// }
	}]);
	const [isOpen, setIsOpen] = useState<boolean>(true);   // 展开收回导航栏

	useEffect(() => {
		matchRouter();
		props.location.pathname === '/' ? HeaderStore.setIsPlay(true) : HeaderStore.setIsPlay(false);
	}, [props.location.pathname]);

	// 页面加载匹配进入当前的路由
	let matchRouter = (): void => {
		let url = props.location.pathname;
		highlightNav(url);
	}

	// 点击最底端导航
	let clickBottomNav = (item: any, index: number): void => {
		highlightNav(item.url);
		if (item.childrens) {
		} else {
			props.history.replace(item.url);
			item.url === '/' ? HeaderStore.setIsPlay(true) : HeaderStore.setIsPlay(false);
		}
	}

	// 高亮选中的栏
	let highlightNav = (url: string, children?: any, parentUrl?: string): void => {
		let arr = navs.map((nav) => {
			if (children) {
				if (nav.url === parentUrl) {
					nav.childrens && nav.childrens.map((item: any) => {
						item.active = url === item.url ? true : false;
					});
				}
			} else {
				nav.active = url === nav.url ? true : false;
			}
			return nav;
		});
		setNavs(arr);
	}

	// 左边展开缩回按钮
	let handleMore = () => {
		setIsOpen(!isOpen);
	}

	return <footer className="footer" >
		<div className="bottom-footer-wrap" style={{ width: isOpen ? `${navs.length * 60 + 80}px` : '50px' }}>
			<div className={`icon-left-wrap ${isOpen ? 'open' : 'close'}`} onClick={() => handleMore()}>
				<img className="icon" src={isOpen ? leftIcon : icon_more} alt="" />
			</div>

			<nav className="footer-nav-wrap" style={{ width: isOpen ? `${navs.length * 60 + 30}px` : '0' }}>
				{navs.map((item, index) => <div key={index} className="item" onClick={() => clickBottomNav(item, index)}>
					<img className="icon" src={item.active ? item.activeIcon : item.icon} alt="" />
					<span className={item.active ? 'name active' : 'name'}>{item.name}</span>
				</div>)}
			</nav>
			<div className="seat" style={{ width: isOpen ? `30px` : '0' }}>
				<span className="arrow" style={{ display: isOpen ? `block` : 'none' }}></span>
			</div>
		</div>
	</footer >
})

export default withRouter(Footer);
